import * as THREE from 'three';

/**
 * AIRFRAME MORPH CONTROLLER // KEVIN ARTHUR DE LIMA
 * Transitions between Hexacopter, Hybrid-VTOL QuadPlane, and Micro-Quad configurations.
 */

export function createMorphController(groups) {
  let activeConfig = 'hexacopter';

  function setConfiguration(configName) {
    if (activeConfig === configName) return;
    activeConfig = configName;

    switch (configName) {
      case 'hybrid-vtol':
        // A.E.R.I.S. & Prometheus Scout: QuadPlane layout with wings, twin booms, pusher
        groups.vtolWings.visible = true;
        groups.vtolBooms.visible = true;
        groups.vtolPusher.visible = true;
        groups.microDucts.visible = false;
        if (groups.armsAndMotors.children) {
          // Keep 4 VTOL lift motors active
          groups.armsAndMotors.children.forEach((arm, idx) => {
            arm.visible = idx !== 1 && idx !== 4; // Hide transverse arms for clean QuadPlane
          });
        }
        break;

      case 'micro-quad':
        // ESP32 Micro-Drone & Agri POCs: compact ducted micro-quad layout
        groups.vtolWings.visible = false;
        groups.vtolBooms.visible = false;
        groups.vtolPusher.visible = false;
        groups.microDucts.visible = true;
        if (groups.armsAndMotors.children) {
          groups.armsAndMotors.children.forEach((arm, idx) => {
            arm.visible = idx % 2 === 0; // 4 micro motors
          });
        }
        break;

      case 'hexacopter':
      default:
        // Kestrel / Baseline: 6-rotor radial hexacopter
        groups.vtolWings.visible = false;
        groups.vtolBooms.visible = false;
        groups.vtolPusher.visible = false;
        groups.microDucts.visible = false;
        if (groups.armsAndMotors.children) {
          groups.armsAndMotors.children.forEach(arm => {
            arm.visible = true;
          });
        }
        break;
    }
  }

  return {
    setConfiguration,
    getActiveConfig: () => activeConfig
  };
}
